module.exports = __webpack_public_path__ + "img/35.bd28b6f7.jpg";